import {TranslateService} from '@ngx-translate/core';
import {MatPaginatorIntl} from '@angular/material/paginator';
import {marker} from '@biesbjerg/ngx-translate-extract-marker';

const itemsPerPage = marker('Items per page');
const next = marker('Next page');
const previous = marker('Previous page');
const firstPage = marker('First page');
const lastPage = marker('Last page');
const of = marker('of');

export class PaginatorIntlService extends MatPaginatorIntl {
  translate: TranslateService;
  itemsPerPageLabel = 'Items per page';
  nextPageLabel = 'Next page';
  previousPageLabel = 'Previous page';
  firstPageLabel = 'First page';
  lastPageLabel = 'Last page';

  getRangeLabel = (page, pageSize, length) => {
    const ofLabel = this.translate ? this.translate.instant(of) : 'of';
    if (length === 0 || pageSize === 0) {
      return '0 ' + ofLabel + ' ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    // If the start index exceeds the list length, do not try and fix the end index to the end.
    const endIndex = startIndex < length ?
      Math.min(startIndex + pageSize, length) :
      startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' ' + ofLabel + ' ' + length;
  }

  injectTranslateService(translate: TranslateService) {
    this.translate = translate;

    this.translate.onLangChange.subscribe(() => {
      this.translateLabels();
    });

    this.translateLabels();
  }

  translateLabels() {
    this.itemsPerPageLabel = this.translate.instant(itemsPerPage);
    this.nextPageLabel = this.translate.instant(next);
    this.previousPageLabel = this.translate.instant(previous);
    this.firstPageLabel = this.translate.instant(firstPage);
    this.lastPageLabel = this.translate.instant(lastPage);

    this.changes.next();
  }

}
